export const IConfirmDialog = {
  title: "",
  message: "",
  showButtons: { cancel: false, accept: false },
  direction: "start",
  buttonsName: { cancel: "", accept: "" },
};
